import flatMap from "lodash/flatMap";
import isNil from "lodash/isNil";
import map from "lodash/map";
import { areOptionsGrouped } from "PFCore/hooks/queries/options/use_options.utils";
import { Id } from "PFTypes";
import { Option, OptionOriginal, SelectOptions } from "PFTypes/options";
export const DROPDOWN_MAX_HEIGHT = 310;

export const getIds = (value: Id | Id[] | undefined): Id[] => {
  if (isNil(value)) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

export const flattenOptions = <T extends OptionOriginal>(options: SelectOptions<T>): Option<T>[] =>
  areOptionsGrouped(options)
    ? flatMap(options, (group) =>
        map(group.options, (flatOption) => ({ disabled: group.disabled, ...flatOption }))
      )
    : options;

export const getHighlightedOptionId = <T extends OptionOriginal>(
  index: number | null,
  options: SelectOptions<T>,
  dropdownId: string
) => (!isNil(index) ? `${dropdownId}-${flattenOptions(options)[index]?.id}` : undefined);
